import { useState } from "react";
import { Link } from "@remix-run/react";
import { User } from "@prisma/client";
import icon from "~/assets/icon.png";
import { HomeIcon, LogOutIcon, Settings2Icon, UserIcon } from "lucide-react";


export function NavBar({ user }: { user: User | null }) {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const links = [
      { to: "/", label: <HomeIcon /> },
      { to: "/profile", label: <UserIcon /> },
      { to: "/logout", label: <LogOutIcon /> },
    ]

    if (user?.isAdmin) {
      links.push({
        to: "/admin",
        label: <Settings2Icon className="text-bar-accent w-5 h-5" aria-label="Admin" />,
      });
    }
  
    return (
    <header className="sticky top-0 w-full flex items-center justify-between px-4 py-3 bg-bar-surface/80 backdrop-blur-xl border-b border-white/5 shadow-bar relative z-50">
            <div className="flex items-center gap-3">
              <img src={icon} alt="Hermansbar logo" className="h-9 w-9 rounded-full ring-2 ring-bar-accent/30" />
              <span className="text-xl font-bold text-bar-cream tracking-tight">Hermansbar</span>
            </div>
            
            {/* Hamburger menu button for mobile */}
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="md:hidden p-2.5 rounded-lg text-bar-cream hover:bg-white/10 transition-colors"
              aria-label="Toggle menu"
            >
              <svg
                className="w-6 h-6"
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                {isMenuOpen ? (
                  <path d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path d="M4 6h16M4 12h16M4 18h16" />
                )}
              </svg>
            </button>
  
            {/* Desktop navigation */}
            <nav className="hidden md:flex items-center gap-1">
              {user ? links.map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  className="p-2.5 rounded-lg text-bar-cream/80 hover:text-bar-accent hover:bg-white/5 transition-all duration-200"
                >
                  {link.label}
                </Link>
              )) : (
                <Link
                  to="/login"
                  className="px-4 py-2 rounded-full bg-bar-accent text-bar-dark font-semibold hover:bg-bar-accent-hover transition-colors"
                >
                  Login
                </Link>
              )}
            </nav>
  
            {/* Mobile navigation */}
            <nav
              className={`md:hidden absolute top-full left-0 right-0 bg-bar-surface/95 backdrop-blur-xl border-b border-white/5 shadow-bar-lg transition-all duration-300 ease-out z-50 ${
                isMenuOpen ? "opacity-100 visible translate-y-0" : "opacity-0 invisible -translate-y-2"
              }`}
            >
              <div className="flex flex-row items-center justify-center p-4 gap-2">
                {user ? links.map((link) => (
                  <Link
                    key={link.to}
                    to={link.to}
                    onClick={() => setIsMenuOpen(false)}
                    className="p-3 rounded-lg text-bar-cream hover:bg-white/10 transition-colors"
                  >
                    {link.label}
                  </Link>
                )) : (
                  <Link
                    to="/login"
                    onClick={() => setIsMenuOpen(false)}
                    className="px-4 py-2 rounded-full bg-bar-accent text-bar-dark font-semibold"
                  >
                    Login
                  </Link>
                )}
              </div>
            </nav>
          </header>
    )
}